import axios from "axios";
import { format } from 'date-fns/format';
import { DocumentStruct } from "../../common/Interfaces";

interface DocumentsByFileNameParams {
  fileName: string;
  token: string | null
}

export const fetchDocumentsByFileName = async ({fileName, token}: DocumentsByFileNameParams) => {
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: {searchString : fileName}
    };
    const apiResponse = await axios.get(
        process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/Documents/Search",
        config
    );
    const documentsList : DocumentStruct[] = apiResponse.data.map((document: any) => ({
        productRange: document.productRange,
        models: document.models || [],
        productNumbers: document.productNumbers || [],
        serialNumber: document.serialNumber,
        documentType: {
            type: document.documentType? document.documentType.category: null,
            description: document.documentType? document.documentType.subcategory: null,
            guid: document.documentType? document.documentType.guid: null,
        },
        startDate: document.startDate ? format(new Date(document.startDate), 'dd/MM/yyyy') : null,
        endDate: document.stopDate ? format(new Date(document.stopDate), 'dd/MM/yyyy') : null,
        uploadDate: format(new Date(document.createdOn), 'dd/MM/yyyy'),
        advancedUserUpload: document.uploaderRole == "AdvancedUser",
        file: document.fileName || document.url,
        comments: document.comments,
        productCompany: document.productCompany,
        languages: document.languages,
        linkType: document.documentLinkType,
        sasToken: document.sasToken,
        documentReference: document.documentReference
    }));
return documentsList;
}

interface GetDocumentsParams {
    Models: string[] | null,
    ProductNumbers: string[] | null,
    SerialNumber: string | null,
    ProductCompany: string | null
    token: string | null
  }

export const fetchGetDocuments = async ({Models,ProductNumbers,SerialNumber,ProductCompany, token}: GetDocumentsParams) => {
    const config = {
        headers: 
        { 
            Authorization: `Bearer ${token}`, 
            Models: Models,
            ProductNumbers: ProductNumbers,
            SerialNumber: SerialNumber,
            ProductCompany: ProductCompany
        },
    };
    const apiResponse = await axios.get(
        process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL + "/v1/SIMDocuments/Documents",
        config
    );
    const documentsList : DocumentStruct[] = apiResponse.data.map((document: any) => ({
        productRange: document.productRange,
        models: document.models || [],
        productNumbers: document.productNumbers || [],
        serialNumber: document.serialNumber,
        documentType: {
            type: document.documentType? document.documentType.category: null,
            description: document.documentType? document.documentType.subcategory: null,
            guid: document.documentType? document.documentType.guid: null,
        },
        startDate: document.startDate ? format(new Date(document.startDate), 'dd/MM/yyyy'):null,
        endDate: document.stopDate ?  format(new Date(document.stopDate), 'dd/MM/yyyy'):null,
        uploadDate: format(new Date(document.createdOn), 'dd/MM/yyyy'),
        advancedUserUpload: document.uploaderRole == "AdvancedUser",
        file: document.fileName || document.url,
        comments: document.comments,
        productCompany: document.productCompany,
        languages: document.languages,
        linkType: document.documentLinkType,
        sasToken: document.sasToken,
        documentReference: document.documentReference
    }));
return documentsList;

}